import { Col, Row } from "react-bootstrap";
import * as icon from "react-bootstrap-icons";
import { Route, Routes } from "react-router-dom";
import { AuthCubit } from "../../blocs/auth/AuthBloc";
import { AuthState } from "../../blocs/auth/authStates";
import useCubit from "../../blocs/hooks";
import { UserRight, hasRight } from "../../core/models/User";
import { kNavBarHeight } from "../../core/utils/constants";
import { SideNavigationItem } from "../core/SideNavigationItem";
import { BlogsAdminList } from "./Blogs/BlogsAdminList";
import { CommentsList } from "./Comments/CommentsList";
import { ContactMeEditor } from "./ContactMe/ContactMeEditor";
import { ResumeHistory } from "./Resume/ResumeHistory";
import { UsersList } from "./Users/UsersList";
import { ZahraFootersList } from "./Zahra/ZahraFootersList";
import { ZahraHeadersList } from "./Zahra/ZahraHeadersList";
import { ZahraMemoriesList } from "./Zahra/ZahraMemoriesList";
import { ZahraSongsList } from "./Zahra/ZahraSongsList";

export function AdminDashboard() {
    const authCubit = AuthCubit.getInstance();
    const authState: AuthState = useCubit(authCubit);
    return <div style={{
        height: '98vh'
    }}>
        <Row>
            <Col xs={1} style={{ paddingTop: kNavBarHeight, position: "fixed" }}>
                {
                    hasRight(UserRight.canUpdateUsers | UserRight.canCreateUsers | UserRight.canDeleteUsers, authState.user!)
                    && <SideNavigationItem title="Users" path="users">
                        <icon.PersonWorkspace size={24} />
                    </SideNavigationItem>
                }
                {
                    hasRight(UserRight.canCreatePost
                        | UserRight.canDeletePost
                        | UserRight.canUpdatePost
                        | UserRight.canDeleteOthersPosts,
                        authState.user!)
                    && <SideNavigationItem title="Blog" path="blog">
                        <icon.Newspaper size={24} />
                    </SideNavigationItem>
                }
                {
                    hasRight(UserRight.canDeleteOthersComments, authState.user!)
                    && <SideNavigationItem title="Comments" path="comments">
                        <icon.Speaker size={24} />
                    </SideNavigationItem>
                }
                {
                    hasRight(UserRight.zahra, authState.user!) && <>
                        <SideNavigationItem title="Zahra - Memories" path="zahra/memories">
                            <icon.Flower3 size={24} />
                        </SideNavigationItem>
                        <SideNavigationItem title="Zahra - Songs" path="zahra/songs">
                            <icon.Flower2 size={24} />
                        </SideNavigationItem>
                        <SideNavigationItem title="Zahra - Header" path="zahra/headers">
                            <icon.CardHeading size={24} />
                        </SideNavigationItem>
                        <SideNavigationItem title="Zahra - Footer" path="zahra/footers">
                            <icon.CardText size={24} />
                        </SideNavigationItem>
                    </>
                }
                {
                    hasRight(UserRight.canUpdateResume, authState.user!)
                    && <SideNavigationItem title="Resume" path="resume">
                        <icon.EnvelopePaper size={24} />
                    </SideNavigationItem>
                }
                {
                    hasRight(UserRight.canUpdateContactMe, authState.user!)
                    && <SideNavigationItem title="Contact me" path="contact-me">
                        <icon.Chat size={24} />
                    </SideNavigationItem>
                }
            </Col>
            <Col xs={1} />
            <Col>
                <Routes>
                    <Route Component={BlogsAdminList} path="blog" />
                    <Route Component={ZahraMemoriesList} path="zahra/memories" />
                    <Route Component={ZahraSongsList} path="zahra/songs" />
                    <Route Component={ZahraHeadersList} path="zahra/headers" />
                    <Route Component={ZahraFootersList} path="zahra/footers" />
                    <Route Component={ResumeHistory} path="resume" />
                    <Route Component={ContactMeEditor} path="contact-me" />
                    <Route Component={UsersList} path="users" />
                    <Route Component={CommentsList} path="comments" />
                </Routes>
            </Col>
        </Row>
    </div>
}
